import { createElement } from "react";

export const SwitchableQuestions = ({ questionTemplates, type, ...rest }) => {
  var props = { ...questionTemplates[type].componentProps, ...rest };
  return createElement(questionTemplates[type].component, props);
};
